import { createAsyncThunk } from '@reduxjs/toolkit';
import { _appointmentUrls } from '@custom/Utils/constants/apiUrls';

const appointmentDetailsbyUID = createAsyncThunk('appointmentDetailbyUID', async (payload: [{ patientId: string, UHID: string }]) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let url = `${_appointmentUrls.detailByUID}`;
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
         payload
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch appointment details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });



export default appointmentDetailsbyUID;
